import {createContext} from 'react';

const LocaleContext = createContext(undefined as (undefined | Record<string, any>));

export default LocaleContext;
